"use strict";

const getNumberOfColumns = ({
  selectedProducts,
  selectedProductsLimit,
  products
}) => {
  if (products.length <= 5) return products.length;
  if (selectedProducts.length === selectedProductsLimit) return selectedProductsLimit;
  if (selectedProducts.length === 1) return 3;
  return selectedProducts.length + 1;
};
export { getNumberOfColumns };
//# sourceMappingURL=getNumberOfColumns.mjs.map
